// extracted by mini-css-extract-plugin
export default {"container":"virtual-balance_container__0wyHp","verticalFiller":"virtual-balance_verticalFiller__CFWfy"};